import { Outlet } from 'react-router-dom';
import { Logo } from '@pnl/ui';

/**
 * Layout para telas públicas de autenticação (login, recuperação, etc).
 * Split: brand panel à esquerda + form à direita.
 */
export function AuthLayout() {
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-[1fr_minmax(420px,520px)]">
      {/* Brand panel — só lg+ */}
      <aside className="bg-brand-900 relative hidden overflow-hidden lg:block">
        <div className="bg-dot-grid bg-dot-md absolute inset-0 opacity-20" aria-hidden />
        <div
          className="absolute -right-32 -top-32 h-[500px] w-[500px] rounded-full opacity-50"
          style={{
            background: 'radial-gradient(circle, rgba(30,111,217,0.5) 0%, transparent 70%)',
          }}
          aria-hidden
        />
        <div className="relative flex h-full flex-col justify-between p-12 text-white">
          <Logo tone="dark" />
          <div className="max-w-md">
            <p className="text-2xs text-brand-400 font-semibold uppercase tracking-widest">
              Painel administrativo
            </p>
            <h1 className="font-display mt-3 text-4xl font-semibold leading-tight tracking-tight">
              Gerencie traders, contas virtuais, planos e saques numa única superfície.
            </h1>
            <p className="text-brand-100 mt-4 text-sm">
              B3 + Forex/CFD · Multi-conta · CSV Nelogica · Cobrança recorrente · Autentique.
            </p>
          </div>
          <p className="text-2xs text-brand-200">© PnL Global · Mesa Proprietária</p>
        </div>
      </aside>

      {/* Form panel */}
      <main className="bg-ink-50 flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
